import * as React from "react"
import { Box, Typography } from "@mui/material"
import { CircularPercentageSeeker } from "@ui-seeker/core"


export default function StockSummaryCircularPercentage({ title, percentage }) {
    return <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {title && <Typography variant="subtitle1" className="label" sx={{ display: "inline", fontSize: 12 }}>
            {title}
        </Typography>}
        <CircularPercentageSeeker
            value={percentage}
            pattern={[
                { value: 89, color: "success.main" },
                { value: 79, color: "success.light" },
                { value: 49, color: "warning.main" },
                { value: "else", color: "error.main" }
            ]}
        />
    </Box>
}